import { __, useLocale } from '@modules';
import React, { useEffect, useState } from 'react';

interface RedirectBannerProps {
  targetUrl: string;
}

const RedirectBanner: React.FC<RedirectBannerProps> = ({ targetUrl }) => {
  const [countdown, setCountdown] = useState(5);
  const locale = useLocale();
  const validLocale = locale === 'fr' ? 'en' : locale;
  const targetLocaleUrl = targetUrl.replace('{locale}', validLocale);

  useEffect(() => {
    if (countdown === 0) {
      window.location.href = targetLocaleUrl; // Use history.push(targetUrl) for internal routing
    } else {
      const timer = setInterval(() => setCountdown(countdown - 1), 1000);
      return () => clearInterval(timer);
    }
  }, [countdown, targetLocaleUrl]);

  return (
    <div
      className='redirect-banner-overlay'
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.6)',
        zIndex: 1000,
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          display: 'flex',
          height: '100vh',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div
          className='redirect-banner-content'
          style={{
            background: '#fff',
            padding: '2rem',
            borderRadius: '12px',
            boxShadow: '0 2px 16px rgba(0,0,0,0.1)',
            textAlign: 'center',
            height: 'fit-content',
            maxWidth: '90vw',
          }}
        >
          <p style={{ fontSize: '1.3rem', margin: '0 0 1.5rem 0', fontWeight: 600 }}>{__('common.redirect.resourceMoved')}</p>
          <p>
            {__('common.redirect.willBeRedirectedIn')} {countdown} {__('common.redirect.seconds')} {__('common.redirect.to')}{' '}
            <a href={targetLocaleUrl} style={{ color: '#0163b6', textDecoration: 'underline' }}>
              {__('common.redirect.newLocation')}
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  );
};

export default RedirectBanner;
